import React, {useEffect, useState} from 'react';
import {
  Grid,
  TextField, Stepper, Step, IconButton, Tooltip, InputAdornment,
  Paper, Typography, Autocomplete, Box,
  Button, MenuItem, InputLabel,Select, FormControl, 
} from '@mui/material';


import visitorService from '../../services/visitorService'

import { useSelector,useDispatch } from 'react-redux';
import {  
  selectAllFloors,
}  from '../../store/floorSlice'


import { generatePhoneDetail } from '../../utils/phoneUtil';


import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';

import CardContent from '@mui/material/CardContent';


import {useAppAuthContext} from '../../utils/AppAuthContext'

import {usePlayContext} from '../../utils/PlayContext';

import { Navigate, useLocation, useNavigate, useParams } from 'react-router-dom';



import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';



const InquiryVisitors = () => {

  const navigate = useNavigate()
  
  const {userInfo, managedHosts} = useAppAuthContext()
  
  const {
      setOp,
      status, setStatus, setAppTitle, 
      setErrorMessage,  setErrorTitle,
      setTenantLogo, openSnackToast
    }=usePlayContext()


  const dispatch = useDispatch()
  const floors = useSelector(selectAllFloors)

  
  const [host, setHost] = React.useState('');
  const [name, setName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [phone, setPhone] = React.useState('')
  
  const [company, setCompany] = React.useState('');
  
  const [queryClicked, setQueryClicked] = React.useState(true);
  const [tableData, setTableData] = React.useState([]);
  const [pageSize, setPageSize] = React.useState(10);
  const [pageNumber, setPageNumber] = React.useState(0);
  const [totalRecords, setTotalRecords] = React.useState(0);
  const [searchCriteria, setSearchCriteria] = React.useState({});
  

  const fetcPagedhData = async(searchCriteria)=>{
    setStatus('processing')
    try
    {
      let response = await visitorService.query(searchCriteria)
    
      let data = response.data;
      console.log(data)

      if (data.content)
      {
          data.content.forEach(generatePhoneDetail)
      }

      setTableData(data.content)
      setTotalRecords(data.totalElements)
      setStatus('success')

    }
    catch (ex)
    {
      setStatus('error')
      setErrorMessage("Network retrival error")
    }

  }
  
  useEffect(() => {
    setAppTitle(  ['Administration','Visitor Records', ])
    setErrorMessage('')
    setErrorTitle('')

    if (queryClicked)
    {
        let x={...searchCriteria, pageSize,pageNumber}  
        fetcPagedhData(x);

    }

    return () => {

    }

  }, [searchCriteria, pageNumber, pageSize, queryClicked])

  const doReset = ()=>
  {
      setHost('')
      setName('')
      setPhone('')
    
      setEmail('')
      setCompany('')
      
      setQueryClicked(false)
      setSearchCriteria({})
      setTableData([])
      setTotalRecords(0)
  }
 
  const doSearch = async ()=>
  {
      let errNo=0

      let phone1 = phone ? phone.trim():''
      phone1 = phone1.replace(' ','-')


      let postBody={
          name,
          phone:phone1,
          email,
          company,
          pageNumber,
          pageSize,
          host,
      }



      
      if (errNo>0) return
      
      setQueryClicked(true)
      setSearchCriteria(postBody)
      
  }

  const handleChangePage = (event, newPage) => {
   // alert('New Page--'+newPage)
    setPageNumber(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPageSize(event.target.value);
   // alert('New Page Size--'+event.target.value)
    setPageNumber(0);
  };

  return (
    <Box>
      <Box sx={{ p:1 }}>
        <Card sx={{width:'100%', m:0, p:0,  border:1}}  raised>
            <CardContent sx={{mx:1, mt:1, mb:0, pt:1, pb:0}}>
        <Grid
          container 
          spacing={1}
          direction={'row'}
          columns={24}
          sx={{pb:0,mb:0}}
        >
               <Grid item xs={12} sm={6}  lg={4}  md={4} >
                    
                <TextField 
                      size='small'
                        fullWidth  variant='outlined'
                    value={name}
                    onChange={e=>setName(e.target.value)}
                    id="id_name"
                    label="Visitor's Name"
                  
                  />
            </Grid>
            <Grid item xs={12} sm={6}  lg={4}  md={4} >
              <Autocomplete 
                    fullWidth

                    forcePopupIcon={false}
                    freeSolo
                    size='small'
                    id="id_email" 
                    
                    value={email}
                    options={[]} 
                    onChange = { (e, newValue)=>{setEmail(newValue);  } }
                    renderInput={(params) => 
                        <TextField {...params} 
                          
                          onChange = { e=>{setEmail(e.target.value);}}
                          label="Visitor's Email"  
                          
                          />}

                    />
            
          </Grid>
            <Grid item xs={12} sm={6}  lg={4}  md={4} >
              <Autocomplete 
                    fullWidth

                    forcePopupIcon={false}
                    freeSolo
                    size='small'
                    id="id_phone" 
                    
                    value={phone}
                    options={[]} 
                    onChange = { (e, newValue)=>{setPhone(newValue);  } }
                    renderInput={(params) => 
                        <TextField {...params} 
                          
                          onChange = { e=>{setPhone(e.target.value);}}
                          label="Visitor's Phone Number"  
                          
                          />}

                    />
            
          </Grid>

         
           <Grid item xs={12} sm={6} lg={4} md={4} sx={{  }}>
             <Autocomplete 
                fullWidth
                freeSolo
                size='small'
                id="id_company" 
                
                value={company}
                options={[]} 
                //onChange = { (e, newValue)=>{;   } }
                onChange = { (e, newValue)=>{setCompany(newValue);}}
                renderInput={(params) => 
                    <TextField {...params} 
                      onChange = { e=>{setCompany(e.target.value);}}
                      label="Visitor's Organization"  
                      />}
                />
          </Grid>   
         
          {
                  userInfo.idTokenClaims.roles.includes('ADMIN') &&
                  <Grid item xs={12} sm={6}  lg={4}  md={4} >
                  <FormControl   fullWidth size='small'>
                    <InputLabel id="id_host_label" >Host</InputLabel>
                        <Select
                            
                            labelId="id_host_label"
                            id="id_host"
                            value={host}
                            label="Host"
                            onChange={(e)=>setHost(e.target.value)}
                            
                            >
                          <MenuItem value={''}>ALL</MenuItem>
                          {
                              managedHosts && managedHosts.map( (u)=>
                              <MenuItem key={u.userName} value={u.userName}>{u.fullName}</MenuItem>
                              )
                          }
                      </Select>
                                
                    </FormControl>
              
            </Grid>


              }
          <Grid item xs={12} sm={6} md={4} lg={4} sx={{  }}>
              <Box sx={{mt:1,display:'flex', width:'100%', justifyContent: 'space-around'}}>

                  <Button variant="outlined"  
					color='primary'  
                    onClick={doSearch}
                  > Search</Button>
                  <Button variant="outlined"  color='info'  
                    onClick={doReset}
                  > Clear</Button>

              </Box>
          </Grid>                          
        </Grid>

        </CardContent>
        </Card>
        <Box sx={{my:1}}>
          <TableContainer component={Paper} >
            <Table aria-label="collapsible table" size='small' >
            <TableHead>
                <TableRow sx={{bgcolor:'#6495ED'}}>
                    <TableCell align="center" style={{border: '1px solid LightGray', fontWeight: 600}}>ID</TableCell>
                  
                    <TableCell align="center" style={{border: '1px solid LightGray', fontWeight: 600}}>NAME</TableCell>
                    
                    <TableCell align="center" style={{border: '1px solid LightGray', fontWeight: 600}}>PHONE</TableCell>
                    <TableCell align="center"  style={{border: '1px solid LightGray', fontWeight: 600}}>EMAIL</TableCell>
                    <TableCell align="center" style={{border: '1px solid LightGray', fontWeight: 600}}>ORGANIZATION</TableCell>

                    <TableCell align="center" style={{border: '1px solid LightGray', fontWeight: 600}}>HOST</TableCell>
                    <TableCell align="center" style={{border: '1px solid LightGray', fontWeight: 600}}>MODIFY TIME</TableCell>
                    <TableCell align="center" style={{border: '1px solid LightGray', fontWeight: 600}}>CREATE TIME</TableCell>
                    
                    
                  </TableRow>
                </TableHead>
                <TableBody>
                  { tableData && tableData.length>0 &&
                      tableData.map((row, i)=>

                        <TableRow key={row.id}>
                               <TableCell  style={{border: '1px solid LightGray', whiteSpace:'nowrap'}}>
                                  <strong>{row.id}</strong>
                              </TableCell>
                              <TableCell  style={{border: '1px solid LightGray', whiteSpace:'nowrap'}}>
                                  {row.name}
                              </TableCell>
      
                              <TableCell  style={{border: '1px solid LightGray', whiteSpace:'nowrap'}}>
                                  {row.phoneDisplay}
                              </TableCell>
                              <TableCell  style={{border: '1px solid LightGray', whiteSpace:'nowrap'}}>
                                  {row.email}
                              </TableCell>
                              
                              <TableCell  style={{border: '1px solid LightGray', whiteSpace:'nowrap'}}>
                                  {row.company}
                              </TableCell>
                              <TableCell  style={{border: '1px solid LightGray', whiteSpace:'nowrap'}}>
                                  {row.host}
                              </TableCell>
                              <TableCell  style={{border: '1px solid LightGray', whiteSpace:'nowrap'}}>
                                  {row.updatedTm}
                              </TableCell>
                              <TableCell  style={{border: '1px solid LightGray', whiteSpace:'nowrap'}}>
                                  {row.createdTm}
                              </TableCell>
                              
                        </TableRow>

                      )

                  }

              </TableBody>
      
      
            </Table>
        </TableContainer>
        <TablePagination
            rowsPerPageOptions={[10, 20, 50]}
            component="div"
       
        // backIconButtonProps={{
        //   color: "secondary"
        // }}
        // nextIconButtonProps={{ color: "secondary" }}
        // SelectProps={{
        //   inputProps: {
        //     "aria-label": "page number"
        //   }
        // }}        
        
        showFirstButton={true}
        showLastButton={true}
              count={totalRecords}
              rowsPerPage={pageSize}
              page={pageNumber}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              //ActionsComponent={TablePaginationActions}
      />
       </Box>
      </Box>

       
      
</Box>
      
    
  );
};


export default InquiryVisitors;
